import { createSlice } from '@reduxjs/toolkit';

const modal = createSlice({
  name: 'modal',
  initialState: {},
  reducers: {
    openModal(state, action) {
      const { name, data } = action.payload;
      state = {
        ...state,
        [name]: {
          open: true,
          data,
        },
      };

      return state;
    },
    closeModal(state, action) {
      const { name } = action.payload;
      state = {
        ...state,
        [name]: {
          open: false,
        },
      };

      return state;
    },
  },
});

export const { openModal, closeModal } = modal.actions;

export default modal.reducer;
